module.exports = __webpack_public_path__ + "group-11.svg?ccb7385198a280961cb65c2140b0cdf0";